import * as React from 'react';
import { Link } from 'react-router-dom';

import { SocialNetworks } from '../../../../components/SocialNetworks/index';
import { ROUTES } from '../../../../router/consts';
import { Container } from '../Container';

import './index.scss';

export const Footer: React.FC = () => {
    return (
        <footer>
            <Container>
                <div className="footer-wrapper">
                    <SocialNetworks />
                    <Link to={ROUTES.LOGIN}>
                        <div className="personal-account">
                            <i className="icon-personal" />
                            Personal Account
                        </div>
                    </Link>
                    <span className="copyrights">
                        © 2014 – {new Date().getFullYear()} SCOUT Agency
                    </span>
                </div>
            </Container>
        </footer>
    );
};
